import React from 'react';

type DashboardDateInputProps = {
  value: string;
  min: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  ariaLabel: string;
  displayValue?: string;
  placeholder?: string;
  title?: string;
  disabled?: boolean;
  wrapperClassName?: string;
};

const DashboardDateInput: React.FC<DashboardDateInputProps> = ({
  value,
  min,
  onChange,
  ariaLabel,
  displayValue,
  placeholder = 'Select date',
  title,
  disabled = false,
  wrapperClassName = '',
}) => {
  const resolvedDisplayValue = displayValue || value || placeholder;

  return (
    <div className={wrapperClassName}>
      <div className="relative">
        <input
          type="date"
          value={value}
          min={min}
          onChange={onChange}
          disabled={disabled}
          title={title}
          aria-label={ariaLabel}
          className="dashboard-date-input peer absolute inset-0 z-[2] min-h-[44px] w-full rounded-[10px] border px-3 py-2 pl-9 pr-9 text-center text-[11px] [color-scheme:light] opacity-0 cursor-pointer disabled:cursor-not-allowed"
        />
        <div
          aria-hidden="true"
          className={`pointer-events-none flex min-h-[44px] w-full items-center justify-center rounded-[10px] border px-3 py-2 pl-9 pr-9 text-center text-[11px] transition peer-focus-visible:ring-2 peer-focus-visible:ring-[var(--qcl-border)] peer-focus-visible:ring-offset-2 ${
            disabled
              ? 'border-[var(--qcl-border-light)] bg-[var(--qcl-border-light)] text-[var(--qcl-text-muted)]'
              : 'border-[var(--qcl-border)] bg-[var(--qcl-bg)] text-[var(--qcl-text-dim)]'
          }`}
        >
          <span
            aria-hidden="true"
            className="absolute left-3 top-1/2 -translate-y-1/2 text-[13px]"
          >
            📅
          </span>
          <span className="qcl-mono w-full truncate text-center">{resolvedDisplayValue}</span>
        </div>
      </div>
    </div>
  );
};

export default DashboardDateInput;
